const deleteTrash = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M2.789 16h10.857V3.623H2.789zM9.93 8h1.143v4.571H9.931zM7.646 8h1.143v4.571H7.646zM5.36 8h1.143v4.571H5.36zM11.326.891h3.108v1.772H2V.89h3.109L6 0h4.434z"/></svg>',
};

export { deleteTrash as default };
